var exports = {
  "oR": "Toast.module__toast___NHRSdW",
  "Gv": "Toast.module__toastMobile___NHRSdW",
  "qS": "Toast.module__toastDesktop___NHRSdW",
  "Kk": "Toast.module__icon___NHRSdW",
  "PO": "Toast.module__iconSuccess___NHRSdW",
  "m5": "Toast.module__iconError___NHRSdW",
  "oq": "Toast.module__iconMobile___NHRSdW",
  "gB": "Toast.module__iconDesktop___NHRSdW",
  "Qq": "Toast.module__text___NHRSdW",
  "wV": "Toast.module__textMobile___NHRSdW",
  "eL": "Toast.module__textDesktop___NHRSdW",
};

module.exports = exports;
